<template>
    <div class="pro_box">
        <div class="together" v-if="$store.state.detailsbottom==true">
            <div class="top_img">
                <img src="../../../assets/icons/官网首页_slices/details_cases.png" alt="">
                <div class="top_font">
                    <div class="font_title">服务案例</div>
                    <div class="font_deputy">Cases</div>
                </div>
            </div>
            <div class="tbs_box" >
                <div 
                    class="tab_item" 
                    :class="[active.id==item.id?'cactive':'']"
                    @click="tabswitch(item)"
                    v-for="(item,index) of tab" :key="index">
                    {{ item.title }}
                </div>
            </div>
            <div class="content_box" >
                <div 
                    class="cases_iten_box" 
                    @click="check(item)"
                    v-for="(item,index) in caselist" :key="index">
                    <img  :src="item.resource" alt="">
                    <div class="font_box">
                        <div class="font_title">
                            {{ item.title }}
                        </div>
                        <!-- <div class="font_brief">
                            {{ item.subtitle }}
                        </div> -->
                    </div>
                </div>
            </div> 
        </div>
        <div class="details_box" v-if="$store.state.detailsbottom==false">
            <el-breadcrumb separator=">" v-if="$store.state.detailsbottom">
                <el-breadcrumb-item><a @click="off">{{ active.title }}</a></el-breadcrumb-item>
                <el-breadcrumb-item>案例详情</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="md_case_breabrumb" v-else>
                <i class="el-icon-arrow-left" @click="off"></i>
                <div class="breabrumb_title">案例详情</div>
            </div>
            <div class="det_content" v-html="$store.state.htmlcontent"></div>
        </div>
        <bottomnav :display="$store.state.detailsbottom"></bottomnav>
    </div>
</template>
<script>
import bottomnav from './bottomnav.vue'
export default{
    components:{
        bottomnav
    },
    data(){
        return{
            active:null,
            tab:[
                {id:1,title:'法院服务案例'},
                {id:2,title:'企业交付案例'},
            ],
            caselist:[],
            htmlcontent:'',
        }
    },
    created(){
        this.active=this.tab[0]
        this.axioslist()
    },
    methods:{
        axioslist(){
            this.$webhttp.get(`v1/web/type?type=${this.active.id}`).then((res)=>{
                if(res.code==200){
                    this.caselist=res.data
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        off(){
            this.$store.commit('detailsbottom',true)
        },
        check(item){
            this.$store.commit('detailsbottom',false)
            this.$webhttp.get(`v1/web/content?id=${item.id}`).then((res)=>{
                if(res.code==200){
                    // this.htmlcontent=res.data
                    this.$store.commit('htmlcontent',res.data)
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        tabswitch(item){
            this.active=item
            this.axioslist()
           
        }
    },
}
</script>
<style lang="less" scoped>
    .el-breadcrumb{
        margin-top: 40px;
        margin-bottom: 24px;
    }
    .pro_box{
        width: 100%;
        box-sizing: border-box;
        height: 100%;
        .details_box{
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            .md_case_breabrumb{
                box-sizing: border-box;
                width: 100%;
                height: 120px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                .breabrumb_title{
                    font-weight: bold;
                    font-size: 45px;
                    color: #2E2E2E;
                }
                /deep/.el-icon-arrow-left{
                    position: absolute;
                    left: 30px;
                    font-size: 45px;
                    font-weight: bold;
                    cursor: pointer;
                }

            }
            .det_content{
                box-sizing: border-box;   
                padding:20px 40px;
                height: 92%;
                margin-top: 20px;
                overflow: scroll;
                font-size: 40px;
                color: #606060;
                
            }
        }
        .together{
            width: 100%;
            .content_box{
                // min-height: 220px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;
                margin-top: 20px;
                width: 100%;
                padding: 0% 3.5% 0% 3.5%;
                .cases_iten_box:hover{
                    // .font_box{
                    //     border-left: 1px solid  #027DFC;
                    //     border-right: 1px solid  #027DFC;
                    //     border-bottom: 1px solid  #027DFC;
                    //     .font_brief{
                    //         color: #101010;
                    //     }
                    // }
                }
                .cases_iten_box{
                    box-sizing: border-box;
                    margin-bottom: 40px;
                    position: relative;
                    cursor: pointer;
                    height: 560px;
                    width: 100%;
                    box-sizing: border-box;
                    img{
                        box-sizing: border-box;
                        width: 100%;
                        height: 560px;
                        box-sizing: border-box;
                        vertical-align: bottom;
                    }
                    .font_box{
                        height: 80px;
                        width: 100%;
                        line-height: 80px;
                        box-sizing: border-box;
                        position: relative;
                        bottom: 80px;
                        background: rgba(0, 0, 0, 0.5);
                        .font_title{
                            font-weight: bold;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            box-sizing: border-box;
                            color: #ffffff;
                            font-size: 28px;
                            text-align: center;
                            box-sizing: border-box;
                            padding: 0px 25px;
                        }
                        .font_brief{
                            box-sizing: border-box;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2; /* 限制显示的行数为2 */
                            overflow: hidden;
                            font-weight: 400;
                            font-size: 14px;
                            color: #606060;
                            line-height: 21px;
                        }
                    }
                }
            }
            .tbs_box{
                height: 100%;
                box-sizing: border-box;
                padding-top: 45px;
                padding-bottom: 20px;
                width: 100%;
                padding-left: 3.5%;
                display: flex;
                .tab_item:hover{
                    background: #027DFC;
                    font-weight: 400;
                    font-size: 30px;
                    color: #FFFFFF;
                    line-height: 70px;
                }
                .cactive{
                    background: #027DFC !important;
                    color: #FFFFFF !important;
                }
                .tab_item{
                    border: 1px solid #ECECEC;
                    background: #FFFFFF;
                    height: 75px;
                    width: 31%;
                    text-align: center;
                    line-height: 70px;
                    box-sizing: border-box;
                    cursor: pointer;
                    font-weight: 400;
                    font-size: 30px;
                    color: #606060;
                }
        
            } 
            .top_img{
                width: 100%;
                height: 250px;
                position: relative;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .top_font{
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    color: #FFFFFF;
                    text-align: center;
                    transform: translateX(-50%) translateY(-50%);
                    .font_title{
                        font-weight: bold;
                        font-size: 38px;
                        color: #FFFFFF;
                        line-height: 60px;
                        text-shadow: 0px 4px 10px rgba(0,0,0,0.1);
                    }
                    .font_deputy{
                        font-weight: 400;
                        font-size: 36px;
                        color: #FFFFFF;
                        text-shadow: 0px 4px 10px rgba(0,0,0,0.1);
                    }
                }
            }
        }
    }

</style>